import { useCallback, useEffect, useState } from 'react'
import { QrReader } from 'react-qr-reader'
import { QR_CODE_READER_NOT_ERRORS, QR_CODE_READER_ERRORS } from './consts'

interface QrCodeReaderProps {
  width?: string
  height?: string
  onResult: (text: string) => void
  onError: (error: QR_CODE_READER_ERRORS) => void
}

const QrCodeReader = ({
  width,
  height,
  onResult,
  onError,
}: QrCodeReaderProps) => {
  // TODO: delayScan is used here as a workaround to fix react-qr-reader lib issue when it doesn't close camera on component unmount
  //  this issue is known and should be fixed in next lib updates
  const [delayScan, setDelayScan] = useState<number | undefined>(500)
  useEffect(() => {
    return () => setDelayScan(undefined)
  }, [])

  const onQrScanResult = useCallback(
    (result, error) => {
      if (
        error &&
        !QR_CODE_READER_NOT_ERRORS.includes(error?.name) &&
        onError
      ) {
        const errorType =
          error?.name === QR_CODE_READER_ERRORS.NOT_ALLOWED_ERROR
            ? QR_CODE_READER_ERRORS.NOT_ALLOWED_ERROR
            : QR_CODE_READER_ERRORS.UNKNOWN_ERROR
        setDelayScan(undefined)
        onError(errorType)
        console.log(error)
      }

      if (!!result) {
        setDelayScan(undefined)
        onResult(result?.getText())
      }
    },
    [onError, onResult]
  )

  return (
    <>
      <QrReader
        scanDelay={delayScan}
        onResult={onQrScanResult}
        constraints={{
          facingMode: 'environment',
        }}
        containerStyle={{ width: width || '200px', height: height || '200px' }}
        videoStyle={{
          objectFit: 'cover',
        }}
      />
    </>
  )
}

export default QrCodeReader
